export enum ValidationTypes {
  validate,
  validateWith,
  asyncValidate,
  asyncValidateWith
}
